/**
 * Marcador de variante de los tests A/B por redirect (rps) — FUENTE ÚNICA.
 *
 * Estas funciones son PURAS (sin zod ni ninguna dependencia): definen el VALOR que
 * identifica a una variante (`<short id>-variant-<letra>-<YYYYMMDD>`). DEBE ser idéntico
 * en los TRES sitios que lo tocan: el redirect que lo escribe, el SDK que lo lee en la
 * landing, y la API externa que agrupa el revenue por él.
 *
 * Viven en su PROPIO módulo (no en experiments.schema.ts) a propósito: ese archivo importa
 * zod, y el SDK necesita SOLO `utmVariantMarker`. Importándolo desde aquí (vía el subpath
 * `@tracking-web/shared/variantMarker`) el SDK no arrastra zod a su bundle. experiments.schema.ts
 * las re-exporta para que el servidor (redirect/dashboard) las siga importando del barrel sin
 * cambios → una sola definición, imposible que diverja.
 */

/** Stamp UTC del inicio del test: `YYYYMMDD`. */
export function utmStartStamp(d: Date): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}${m}${day}`;
}

/** Slug de la variante (letra) seguro para el utm: solo alfanumérico en minúscula. */
export function utmVariantSlug(name: string, index: number): string {
  const clean = (name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  return clean || String.fromCharCode(97 + index); // a, b, c…
}

/** Short id del test (últimos 8 del id) que va en el marcador. */
export function experimentShortId(id: string): string {
  return id.slice(-8);
}

/**
 * Marcador que identifica a la variante: `<short id del test>-variant-<letra>-<YYYYMMDD>`.
 * Es el VALOR que el redirect escribe en el parámetro `key`, que lee el SDK en la
 * landing, y por el que la API externa agrupa el revenue. DEBE ser idéntico en los tres.
 */
export function utmVariantMarker(
  experimentId: string,
  name: string,
  index: number,
  stamp: string
): string {
  return `${experimentShortId(experimentId)}-variant-${utmVariantSlug(name, index)}-${stamp}`;
}
